import {PARSED_FIELD_TYPES} from "@/includes/parse_psd_data/constants";
import Base from "@/includes/parse_psd_data/psd-types/base";
import { getInstanceByType } from "@/includes/parse_psd_data/type-resolver";
import Template from "@/includes/parse_psd_data/template";
import {recursiveWalker} from "@/includes/parse_psd_data";



export class Folder extends Base {
  name;

  type = PARSED_FIELD_TYPES.FOLDER

  visible;

  children = [];

  uuid;

  width;

  height;

  left;

  top;
  
  opacity;
  
  blendingMode;
  
  groupId;

  buildFromData(templateData) {
    super.buildFromData(templateData)
    this.name = templateData.name;
    this.visible = templateData.visible;
    this.uuid = templateData.uuid;
    this.width = templateData.width;
    this.height = templateData.height;
    this.opacity = templateData.opacity || 1;
    this.blendingMode = templateData.blendingMode || 'normal';
    this.groupId = templateData.groupId ?? null;
    this.children = templateData.children.map((field) => {
      return getInstanceByType({...field, parent: this});
    }).filter(i => !!i);

    this.left = templateData.left;
    this.top = templateData.top;
    
    if (this.left === undefined || this.top === undefined) {
      const fallbackCoords = this.getFallbackCoords();
      
      this.left = fallbackCoords.left;
      this.top = fallbackCoords.top;
    }
  }

  toTemplate() {
    const template = new Template();

    const EXCEPTIONS = [ 'type' ];

    for (const key in this) {
      if (EXCEPTIONS.includes(key)) {
        continue;
      }
      template[key] = this[key]
    }

    template.parent = undefined;

    recursiveWalker(template.children, node => {
      node.left -= template.left
      node.top -= template.top
      if (node.data) {
        node.data.left -= template.left
        node.data.top -= template.top
      }

      if (node.data?.adjustments?.smartObject?.Trnf) {
        node.data.adjustments.smartObject.Trnf = node.data?.adjustments?.smartObject?.Trnf
          .map((item, index) => item - (index % 2 ? template.top : template.left))
      }
    })

    template.left = 0
    template.top = 0

    return template
  }
  
  getFallbackCoords() {
    let left = null;
    let top = null;

    const isFolder = node => node?.type === PARSED_FIELD_TYPES.FOLDER;

    const stack = [...this.children];
    let target = null;

    while (stack.length) {
      const node = stack.shift();
      if (!node) continue;

      if (!isFolder(node)) {
        target = node;
        break;
      }

      if (node.children?.length) {
        stack.unshift(...node.children);
      }
    }

    if (target && target.data.ancestors && target.data.ancestors[0]?.artboard?.coords) {
      left = target.data.ancestors[0].artboard.coords.left;
      top = target.data.ancestors[0].artboard.coords.top;
    }
    
    return { left, top };
  }
}
